import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PrettyTooltipService {

  // tooltipTitle: Texto que se mostrará en la cabecera del tooltip.
  tooltipTitle: string;
  // tooltipText: Texto que se mostrará en el cuerpo del tooltip.
  tooltipText: string;
  // tooltipDirection: Dirección en la que se mostrará el tooltip con referencia al elemento padre
  tooltipDirection: string;
  // currentTag: Elemento padre
  currentTag: HTMLElement;

  // setTooltip(): Método que modifica las propiedades de la clase de acuerdo a los parámetros recibidos
  setTooltip(title: string = null, text: string = null, direction: string = null, tag?: HTMLElement) {
    this.currentTag = tag ? tag : null;
    this.tooltipDirection = direction;
    this.tooltipTitle = title;
    this.tooltipText = text;
  }
}
